import { render, staticRenderFns } from "./ReportDefect.vue?vue&type=template&id=2cbae111&scoped=true&"
import script from "./ReportDefect.vue?vue&type=script&lang=js&"
export * from "./ReportDefect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cbae111",
  null
  
)

export default component.exports